/**
 * Two-letter initials from a display name.
 *   "Stefan Landvogt" → "SL"
 *   "Petra"           → "PE"
 *   ""                → "?"
 */
export function initialsFromName(name: string): string {
  const trimmed = name.trim()
  if (!trimmed) return '?'
  const parts = trimmed.split(/\s+/)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  return trimmed.slice(0, 2).toUpperCase()
}

const PALETTE = [
  ['#ffb199', '#ff5b4d'],
  ['#a5d6a7', '#43a047'],
  ['#90caf9', '#1976d2'],
  ['#ffd180', '#f57c00'],
  ['#b39ddb', '#5e35b1'],
  ['#80cbc4', '#00897b'],
  ['#f48fb1', '#ad1457'],
  ['#ce93d8', '#8e24aa'],
] as const

/** Stable gradient for an avatar background, chosen by hashing the uid. */
export function avatarGradient(uid: string): string {
  let hash = 0
  for (let i = 0; i < uid.length; i++) {
    hash = (hash * 31 + uid.charCodeAt(i)) & 0xffffffff
  }
  const idx = Math.abs(hash) % PALETTE.length
  const [from, to] = PALETTE[idx]
  return `linear-gradient(135deg, ${from}, ${to})`
}
